module.exports = __webpack_public_path__ + "static/media/_virgin-islands.3b3def88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_virgin-islands.svg
// module id = 2362
// module chunks = 7